/**
* Table (RTE) Component
*/
import { Component, registerComponent } from 'js/component.js';
import { isEditModeFooter } from 'js/helpers.js';

const componentName = 'text-table-only';

class TextTableOnly extends Component {

    /**
    * Component Setup
    */
    elements = {
        tableCells: this.element.querySelectorAll('td, th')
    };

    /**
    * Initialize Component
    */
    init() {
        if ((!isEditModeFooter()) && this.elements.tableCells) {
            // Inject divs into table cells to allow control of row height
            for (let i = 0; i < this.elements.tableCells.length; i += 1) {
                const cellContent = this.elements.tableCells[i].innerHTML;
                this.elements.tableCells[i].innerHTML = `<div>${cellContent}</div>`;
            }
        }
    }
}

registerComponent(`.${componentName}`, TextTableOnly);
